import { apiClient, API_ENDPOINTS, TIME_BUDGETS } from '../../../lib';
import type { DsUserInsights } from '@common/types';
import type { SuggestStoreNameResponse } from '@common/api-types';
import type { GetPaymentAggregatesResponse } from '@wix/ambassador-cashier-settings-v2-payment-method-type/types';

export async function suggestStoreName(
  category: string,
  products: string[],
  previousResults: string[],
): Promise<string[]> {
  const response = await apiClient.post<SuggestStoreNameResponse>(
    API_ENDPOINTS.storeSetup.suggestStoreName,
    {
      category,
      products,
      previousResults,
    },
    {
      headers: { 'x-time-budget': `${TIME_BUDGETS.medium}` },
    },
  );
  return response.suggestions;
}

export async function updateSiteSettings(metaSiteId: string, insights: DsUserInsights): Promise<void> {
  await apiClient.post(
    API_ENDPOINTS.site.updateSettings,
    {
      metaSiteId,
      insights,
    },
    {
      headers: { 'x-time-budget': `${TIME_BUDGETS.extended}` },
    },
  );
}

export async function updateComponent(
  metaSiteId: string,
  storeName: string,
  contactDetails: { email?: string; phone?: string },
): Promise<void> {
  await apiClient.post(
    API_ENDPOINTS.site.updateComponent,
    {
      metaSiteId,
      storeName,
      contactDetails,
    },
    {
      headers: { 'x-time-budget': `${TIME_BUDGETS.extended}` },
    },
  );
}

export async function publishSite(metaSiteId: string): Promise<void> {
  await apiClient.post(
    API_ENDPOINTS.site.publish,
    { metaSiteId },
    {
      headers: { 'x-time-budget': `${TIME_BUDGETS.extended}` },
    },
  );
}

export async function connectPaymentProvider(metaSiteId: string): Promise<void> {
  await apiClient.post(
    API_ENDPOINTS.payment.connectProvider,
    { metaSiteId },
    {
      headers: { 'x-time-budget': `${TIME_BUDGETS.extended}` },
    },
  );
}

export async function getPaymentAggregators(metaSiteId: string): Promise<GetPaymentAggregatesResponse> {
  const response = await apiClient.get<GetPaymentAggregatesResponse>(
    API_ENDPOINTS.payment.paymentAggregate(metaSiteId),
    {
      headers: { 'x-time-budget': `${TIME_BUDGETS.extended}` },
    },
  );
  return response;
}
